// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_comp_fss_flat.entity.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { StcsOrgFsdFlatItem } from "./stcs_org_fsd_flat.entity";

export const protobufPackage = "stcs_cmw";

/** v1.1.0 */
export interface StcsCompFssFlat {
  id: string;
  version: string;
  meta: StcsCompFssFlatMeta | undefined;
  pnl_list: StcsOrgFsdFlatItem[];
  bs_list: StcsOrgFsdFlatItem[];
  cf_list: StcsOrgFsdFlatItem[];
}

export interface StcsCompFssFlatMeta {
  obj_created_iso_utc: string;
  obj_updated_iso_utc: string;
  ref_id_org: string;
  ref_id_user: string;
  ref_id_comp: string;
}

function createBaseStcsCompFssFlat(): StcsCompFssFlat {
  return { id: "", version: "", meta: undefined, pnl_list: [], bs_list: [], cf_list: [] };
}

export const StcsCompFssFlat: MessageFns<StcsCompFssFlat> = {
  encode(message: StcsCompFssFlat, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.version !== "") {
      writer.uint32(18).string(message.version);
    }
    if (message.meta !== undefined) {
      StcsCompFssFlatMeta.encode(message.meta, writer.uint32(26).fork()).join();
    }
    for (const v of message.pnl_list) {
      StcsOrgFsdFlatItem.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.bs_list) {
      StcsOrgFsdFlatItem.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.cf_list) {
      StcsOrgFsdFlatItem.encode(v!, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompFssFlat {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompFssFlat();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.version = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.meta = StcsCompFssFlatMeta.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.pnl_list.push(StcsOrgFsdFlatItem.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.bs_list.push(StcsOrgFsdFlatItem.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.cf_list.push(StcsOrgFsdFlatItem.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompFssFlat {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      version: isSet(object.version) ? globalThis.String(object.version) : "",
      meta: isSet(object.meta) ? StcsCompFssFlatMeta.fromJSON(object.meta) : undefined,
      pnl_list: globalThis.Array.isArray(object?.pnl_list)
        ? object.pnl_list.map((e: any) => StcsOrgFsdFlatItem.fromJSON(e))
        : [],
      bs_list: globalThis.Array.isArray(object?.bs_list)
        ? object.bs_list.map((e: any) => StcsOrgFsdFlatItem.fromJSON(e))
        : [],
      cf_list: globalThis.Array.isArray(object?.cf_list)
        ? object.cf_list.map((e: any) => StcsOrgFsdFlatItem.fromJSON(e))
        : [],
    };
  },

  toJSON(message: StcsCompFssFlat): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.meta !== undefined) {
      obj.meta = StcsCompFssFlatMeta.toJSON(message.meta);
    }
    if (message.pnl_list?.length) {
      obj.pnl_list = message.pnl_list.map((e) => StcsOrgFsdFlatItem.toJSON(e));
    }
    if (message.bs_list?.length) {
      obj.bs_list = message.bs_list.map((e) => StcsOrgFsdFlatItem.toJSON(e));
    }
    if (message.cf_list?.length) {
      obj.cf_list = message.cf_list.map((e) => StcsOrgFsdFlatItem.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompFssFlat>, I>>(base?: I): StcsCompFssFlat {
    return StcsCompFssFlat.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompFssFlat>, I>>(object: I): StcsCompFssFlat {
    const message = createBaseStcsCompFssFlat();
    message.id = object.id ?? "";
    message.version = object.version ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? StcsCompFssFlatMeta.fromPartial(object.meta)
      : undefined;
    message.pnl_list = object.pnl_list?.map((e) => StcsOrgFsdFlatItem.fromPartial(e)) || [];
    message.bs_list = object.bs_list?.map((e) => StcsOrgFsdFlatItem.fromPartial(e)) || [];
    message.cf_list = object.cf_list?.map((e) => StcsOrgFsdFlatItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseStcsCompFssFlatMeta(): StcsCompFssFlatMeta {
  return { obj_created_iso_utc: "", obj_updated_iso_utc: "", ref_id_org: "", ref_id_user: "", ref_id_comp: "" };
}

export const StcsCompFssFlatMeta: MessageFns<StcsCompFssFlatMeta> = {
  encode(message: StcsCompFssFlatMeta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.obj_created_iso_utc !== "") {
      writer.uint32(34).string(message.obj_created_iso_utc);
    }
    if (message.obj_updated_iso_utc !== "") {
      writer.uint32(42).string(message.obj_updated_iso_utc);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(50).string(message.ref_id_org);
    }
    if (message.ref_id_user !== "") {
      writer.uint32(58).string(message.ref_id_user);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(90).string(message.ref_id_comp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsCompFssFlatMeta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsCompFssFlatMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.obj_created_iso_utc = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.obj_updated_iso_utc = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsCompFssFlatMeta {
    return {
      obj_created_iso_utc: isSet(object.obj_created_iso_utc) ? globalThis.String(object.obj_created_iso_utc) : "",
      obj_updated_iso_utc: isSet(object.obj_updated_iso_utc) ? globalThis.String(object.obj_updated_iso_utc) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
    };
  },

  toJSON(message: StcsCompFssFlatMeta): unknown {
    const obj: any = {};
    if (message.obj_created_iso_utc !== "") {
      obj.obj_created_iso_utc = message.obj_created_iso_utc;
    }
    if (message.obj_updated_iso_utc !== "") {
      obj.obj_updated_iso_utc = message.obj_updated_iso_utc;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsCompFssFlatMeta>, I>>(base?: I): StcsCompFssFlatMeta {
    return StcsCompFssFlatMeta.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsCompFssFlatMeta>, I>>(object: I): StcsCompFssFlatMeta {
    const message = createBaseStcsCompFssFlatMeta();
    message.obj_created_iso_utc = object.obj_created_iso_utc ?? "";
    message.obj_updated_iso_utc = object.obj_updated_iso_utc ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
